export default function CheckboxDropdownComponent(module) {
    angular.module(module)
        .component('checkboxDropdown', {
            bindings: {
                options: '<',
                placeholder: '@',
                modelAsString: '<?',
                onChange: '&?'
            },
            require: {
                ngModel: 'ngModel'
            },
            template: `
                <div class="dropdown">
                    <a class="placeholder" ng-class="{active: vm.dropdownOpen}" ng-click="vm.toggle()"><span>{{vm.selections.length ? vm.text : vm.placeholder}}</span></a>
                    <div class="options">
                        <div class="custom-radio" ng-repeat="option in vm.options">
                            <input ng-model="option.active" type="checkbox" id="checkbox-dropdown-{{vm._id}}-{{$index}}" ng-true-value="true" ng-false-value="false" ng-change="vm.updateValue(option)">
                            <label for="checkbox-dropdown-{{vm._id}}-{{$index}}">{{option.label}}</label>
                        </div>
                    </div>
                </div>
                <div class="clear-container">
                    <a class="clearer" ng-class="{ hidden: !vm.selections.length}" ng-click="vm.clear()">clear</a>
                </div>
            `,
            controller: checkboxDropdownController,
            controllerAs: 'vm'
        });
    var id = 1;
    checkboxDropdownController.$inject = ['$element', '$scope', '$compile'];
    function checkboxDropdownController($element, $scope, $compile) {
        var vm = this;

        vm.$onInit = () => {
            vm._id = id++;
            if (vm.placeholder) {
                $element[0].addEventListener('mouseleave', vm.close);
            }
            $scope.$on('clear', vm.clear);
            vm.ngModel.$viewChangeListeners.push(vm.updateOptionsStatus);
        }

        vm.$onChanges = changes => {
            if (changes.options && changes.options.currentValue) {
                vm._disabled = changes.options.currentValue && !changes.options.currentValue.length;
                if (vm._disabled) {
                    $element[0].setAttribute('disabled', 'disabled');
                }
                else {
                    $element[0].removeAttribute('disabled');
                }
                vm.updateOptionsStatus();
            }
        }

        vm.clear = () => {
            vm.updateOptionsStatus(true);
            vm.updateModel();
        }

        vm.updateOptionsStatus = (clear) => {
            vm.selections = clear ? [] : vm.ngModel.$viewValue || [];
            if (vm.options) {
                var selectionItems = [];
                vm.options.forEach(option => {
                    var selectionIndex = vm.selections.indexOf(option.value);
                    if (selectionIndex > -1) {
                        option.active = true;
                        selectionItems[selectionIndex] = option;
                    }
                    option.active = vm.selections.indexOf(option.value) > -1;
                });
                if (selectionItems.length) {
                    var text = '';
                    selectionItems.forEach((option, i) => {
                        if (i > 0) {
                            text += ', ';
                        }
                        text += option.label;
                    });
                    vm.text = text;
                }
                else {
                    vm.text = vm.placeholder;
                }
            }
            else {
                vm.text = vm.placeholder;
            }
        }

        vm.toggle = () => {
            if (!vm._disabled) {
                vm.dropdownOpen = !vm.dropdownOpen;
                if (Foundation.MediaQuery.current === 'small' && vm.placeholder) {
                    if (vm.dropdownOpen) {
                        if (!vm._externalOptions) {
                            vm._externalOptions = document.createElement('div');
                            vm._externalOptions.innerHTML = `
                            <div class="head">
                                <span class="placeholder">{{vm.text}}</span>
                                <a class="close close-button light" ng-click="vm.closeExternal()"></a>
                            </div>
                            <div class="options">
                                <div class="custom-radio" ng-repeat="option in vm.options">
                                    <input ng-model="option.active" type="checkbox" id="checkbox-dropdown-{{vm._id}}-{{$index}}" ng-true-value="true" ng-false-value="false" ng-change="vm.updateValue(option)">
                                    <label for="checkbox-dropdown-{{vm._id}}-{{$index}}">{{option.label}}</label>
                                </div>
                            </div>
                        `;
                            vm._externalOptions.id = 'checkbox-dropdown-options-' + vm._id;
                            vm._externalOptions.classList.add('checkbox-dropdown-options');
                            document.body.append(vm._externalOptions);
                            $compile(vm._externalOptions)($scope);
                        }
                        vm._externalOptions.style.display = 'block';
                    }
                    else {
                        vm._externalOptions.style.display = 'none';
                    }
                }
            }
            return false;
        }

        vm.close = () => {
            if (!vm._externalOptions) {
                $scope.$evalAsync(() => {
                    vm.dropdownOpen = false;
                });
            }
        }

        vm.closeExternal = () => {
            vm.dropdownOpen = false;
            vm._externalOptions.style.display = 'none';
        }

        vm.updateValue = option => {
            var index = vm.selections.indexOf(option.value);
            if (index === -1) {
                vm.selections.push(option.value);
                if (vm.selections.length === 1) {
                    vm.text = option.label;
                }
                else {
                    vm.text += ', ' + option.label;
                }
            }
            else {
                vm.selections.splice(index, 1);
                if (!vm.selections.length) {
                    vm.text = vm.placeholder;
                }
                else {
                    var textParts = vm.text.split(', ');
                    textParts.splice(index, 1);
                    vm.text = textParts.join(', ');
                }
            }
            vm.updateModel();
        }

        vm.updateModel = () => {
            if (vm.modelAsString) {
                vm.ngModel.$setViewValue(vm.selections.join(','));
            }
            else {
                vm.ngModel.$setViewValue(vm.selections);
            }
            if (vm.onChange) {
                vm.onChange({
                    selections: vm.selections
                });
            }
        }
    }
}